import { styled } from 'styled-components';
import { colors } from '../../abstracts';
import { dontForwardProps } from '../../util';
import { StyledAction } from '../Action/elements';
export const Container = styled.div.withConfig(dontForwardProps()).withConfig({
  componentId: "aui__sc-1wjnnqk-0"
})(["display:flex;flex-wrap:wrap;gap:0.5rem;", " ", " ", ""], props => props.isStacked && props.hasFullWidthButtons ? `flex-direction: column;` : props.isStacked && !props.hasFullWidthButtons ? `flex-direction: column; align-items: center;` : props.alignment === 'end' ? `flex-direction: row-reverse;` : `justify-content: ${props.alignment};`, props => !props.isStacked &&
// Exclude `isStacked` because flex-basis will shrink the buttons when flex-direction: column
props.hasFullWidthButtons && `
    > *, > ${StyledAction} { 
      flex-grow: 1; 
      flex-basis: 0; 
    }
  `, ({
  isFixedPosition
}) => isFixedPosition && `
    box-shadow: inset 0 1px 0 0 ${colors.neutralBrighter};

    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;

    padding: 1rem;
  `);